const API_URL = 'https://api.dawwin.al-ilm.net'

export type DawwinUser = { id: string; email: string }
export type LoginResult = { user: DawwinUser } | { mfaRequired: true; challenge: string }
export type MfaStatus = { configured: boolean; enabled: boolean; recoveryCodesRemaining: number }

async function authFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  })
  const data = response.status === 204 ? null : await response.json().catch(() => null)
  if (!response.ok) {
    const code = data && typeof data.error === 'string' ? data.error : `http_${response.status}`
    throw new Error(code)
  }
  return data as T
}

export async function getCurrentUser() {
  return (await authFetch<{ user: DawwinUser }>('/auth/me')).user
}

export async function register(email: string, password: string, age13Confirmed:boolean, specialCategoryConsent:boolean) {
  return (await authFetch<{ user: DawwinUser }>('/auth/register', {
    method: 'POST', body: JSON.stringify({ email, password, age_13_confirmed:age13Confirmed, special_category_consent:specialCategoryConsent }),
  })).user
}

export async function login(email: string, password: string): Promise<LoginResult> {
  return authFetch<LoginResult>('/auth/login', { method:'POST', body:JSON.stringify({ email,password }) })
}

export async function verifyMfaLogin(challenge:string,code:string) {
  return (await authFetch<{user:DawwinUser}>('/auth/mfa/verify',{method:'POST',body:JSON.stringify({challenge,code})})).user
}

export async function getMfaStatus(){return authFetch<MfaStatus>('/auth/mfa/status')}
export async function beginMfaSetup(){return authFetch<{secret:string;otpauthUri:string}>('/auth/mfa/setup',{method:'POST'})}
export async function confirmMfaSetup(code:string){return authFetch<{recoveryCodes:string[]}>('/auth/mfa/confirm',{method:'POST',body:JSON.stringify({code})})}
export async function regenerateMfaRecoveryCodes(password:string,code:string){return authFetch<{recoveryCodes:string[]}>('/auth/mfa/recovery/regenerate',{method:'POST',body:JSON.stringify({password,code})})}
export async function disableMfa(password:string,code:string){return authFetch<null>('/auth/mfa/disable',{method:'POST',body:JSON.stringify({password,code})})}

export async function logout() {
  await authFetch<null>('/auth/logout', { method: 'POST' })
  try { sessionStorage.removeItem('dawwin-explore-preview-search-v1') } catch { /* storage unavailable */ }
  try { indexedDB.deleteDatabase('dawwin-explore-index-v1') } catch { /* storage unavailable */ }
}

export type PrivacyStatus={age13Confirmed:boolean;specialCategoryConsent:boolean;consentVersion:string}
export async function getPrivacyStatus(){return authFetch<PrivacyStatus>('/auth/privacy-status')}
export async function recordPrivacyConsent(age13Confirmed:boolean,specialCategoryConsent:boolean){return authFetch<{ok:true}>('/auth/privacy-consent',{method:'POST',body:JSON.stringify({age_13_confirmed:age13Confirmed,special_category_consent:specialCategoryConsent})})}
